import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import '../../../assets/styles/components/AuthForm.css';
import AuthBrandPanel from '../AuthBrandPanel/AuthBrandPanel';
import { REACT_APP_RECAPTCHA_SITE_KEY } from '../Routes/URLs';

const AuthFormShell = ({ pageClassName, title, subtitle, children }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <GoogleReCaptchaProvider reCaptchaKey={REACT_APP_RECAPTCHA_SITE_KEY}>
      <Row className={`auth-page ${pageClassName} g-0`}>
        <AuthBrandPanel tagline={tempedgeTranslator('com.tempedge.msg.public.footer.tagline')} />

        <Col xs={12} sm={12} md={6} lg={5} className="auth-form-col px-3 px-sm-4 py-4 py-md-5">
          <Row className="auth-form-inner g-0 p-3 p-sm-4">
            <Col xs={12} sm={12} md={12} lg={12}>
              <h1 className="auth-title">{title}</h1>
              <Row className="g-0">
                <Col xs="auto">
                  <span className="auth-rule d-block" />
                </Col>
              </Row>
              <p className="auth-subtitle">{subtitle}</p>

              {children}
            </Col>
          </Row>
        </Col>
      </Row>
    </GoogleReCaptchaProvider>
  );
};

export default AuthFormShell;
